import React, { useEffect, useMemo, useState } from "react";

export const STORAGE_KEY_PUBLISHER_COMMUNICATIONS = "wolf_publisher_communications_v1";

export const COMMUNICATION_CATEGORIES = [
  { key: "Talep", label: "Talep", icon: "📌", color: "bg-blue-500/20 text-blue-300 border-blue-500/30" },
  { key: "İstek", label: "İstek", icon: "💡", color: "bg-amber-500/20 text-amber-300 border-amber-500/30" },
  { key: "Şikayet", label: "Şikayet", icon: "⚠️", color: "bg-rose-500/20 text-rose-300 border-rose-500/30" },
  { key: "Bilgi", label: "Bilgi", icon: "ℹ️", color: "bg-cyan-500/20 text-cyan-300 border-cyan-500/30" },
  { key: "Etkinlik & PK", label: "Etkinlik & PK", icon: "⚔️", color: "bg-purple-500/20 text-purple-300 border-purple-500/30" },
  { key: "Teknik Destek", label: "Teknik Destek", icon: "🛠️", color: "bg-orange-500/20 text-orange-300 border-orange-500/30" },
  { key: "Ödeme & Prim", label: "Ödeme & Prim", icon: "💰", color: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30" },
  { key: "Kural & Disiplin", label: "Kural & Disiplin", icon: "📋", color: "bg-red-500/20 text-red-300 border-red-500/30" },
  { key: "Genel", label: "Genel", icon: "💬", color: "bg-slate-500/20 text-slate-300 border-slate-500/30" },
];

export const PUBLISHER_STYLES = [
  { key: "Sohbet & Muhabbet", label: "Sohbet & Muhabbet", icon: "🎙️" },
  { key: "PK & Oyun", label: "PK & Oyun", icon: "⚔️" },
  { key: "Müzik & Şarkı", label: "Müzik & Şarkı", icon: "🎵" },
  { key: "Dans & Gösteri", label: "Dans & Gösteri", icon: "💃" },
  { key: "Komedi & Mizah", label: "Komedi & Mizah", icon: "🎭" },
  { key: "ASMR & Rahatlatıcı", label: "ASMR & Rahatlatıcı", icon: "🎧" },
  { key: "Moda & Makyaj", label: "Moda & Makyaj", icon: "💄" },
  { key: "Sanat & Yetenek", label: "Sanat & Yetenek", icon: "🎨" },
  { key: "Genel / Karma", label: "Genel / Karma", icon: "🌐" },
];

export const INTRO_MEETING_OPTIONS = [
  { key: "yapildi", label: "Görüşme Yapıldı (Evet)", shortLabel: "Görüşüldü", badge: "bg-emerald-500/20 text-emerald-300 border-emerald-500/30", icon: "✓" },
  { key: "yapilmadi", label: "Yapılmadı (Hayır)", shortLabel: "Görüşülmedi", badge: "bg-rose-500/20 text-rose-300 border-rose-500/30", icon: "✕" },
  { key: "beklemede", label: "Beklemede / Randevu", shortLabel: "Beklemede", badge: "bg-amber-500/20 text-amber-300 border-amber-500/30", icon: "⏳" },
];

export function loadAllCommunications() {
  if (typeof window === "undefined") return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY_PUBLISHER_COMMUNICATIONS);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (err) {
    console.warn("CRM İletişim verisi okunamadı:", err);
    return [];
  }
}

export function saveAllCommunications(list) {
  if (typeof window === "undefined") return;
  try {
    localStorage.setItem(STORAGE_KEY_PUBLISHER_COMMUNICATIONS, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent("wolf_crm_updated", { detail: list }));
  } catch (err) {
    console.warn("CRM İletişim verisi kaydedilemedi:", err);
  }
}

export function getCommunicationsForUser(items = [], username = "", hiddenId = "") {
  const cleanUser = String(username || "").replace(/[@\s]+/g, "").toLowerCase();
  const cleanHidden = String(hiddenId || "").trim();

  return (items || []).filter((item) => {
    const itemUser = String(item.publisherUsername || item.username || "").replace(/[@\s]+/g, "").toLowerCase();
    const itemHidden = String(item.hiddenId || "").trim();

    if (cleanUser && itemUser && cleanUser === itemUser) return true;
    if (cleanHidden && itemHidden && cleanHidden === itemHidden) return true;
    return false;
  }).sort((a, b) => new Date(b.createdAt || 0) - new Date(a.createdAt || 0));
}

export function formatDateTimeTr(dateObjOrStr) {
  if (!dateObjOrStr) return "-";
  try {
    const d = typeof dateObjOrStr === "string" ? new Date(dateObjOrStr) : dateObjOrStr;
    if (isNaN(d.getTime())) return String(dateObjOrStr);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2, "0");
    const mins = String(d.getMinutes()).padStart(2, "0");
    return `${day}.${month}.${year} ${hours}:${mins}`;
  } catch {
    return String(dateObjOrStr);
  }
}

/**
 * Slide-over Right Drawer Panel for Publisher CRM
 */
export function PublisherCrmSlideOver({
  publisher = {},
  currentUser = null,
  isOpen = false,
  onClose,
}) {
  const [allComms, setAllComms] = useState(loadAllCommunications);
  const [isAdding, setIsAdding] = useState(false);
  const [direction, setDirection] = useState("publisher_to_manager");
  const [category, setCategory] = useState("Talep");
  const [status, setStatus] = useState("İşlemde");
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);
  const [filterCategory, setFilterCategory] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");

  const pubUsername = publisher?.tiktok_username || publisher?.username || "";
  const pubHiddenId = publisher?.hidden_id || publisher?.hiddenId || "";
  const pubFullName = publisher?.full_name || publisher?.fullName || pubUsername;
  const currentAuthor = currentUser?.fullName || currentUser?.username || "admin";
  const managerName = publisher?.assignedEmployeeUsername || publisher?.managerName || publisher?.manager_username || "Atanmadı";

  useEffect(() => {
    function handleUpdate() {
      setAllComms(loadAllCommunications());
    }
    window.addEventListener("wolf_crm_updated", handleUpdate);
    window.addEventListener("storage", handleUpdate);
    return () => {
      window.removeEventListener("wolf_crm_updated", handleUpdate);
      window.removeEventListener("storage", handleUpdate);
    };
  }, []);

  useEffect(() => {
    function handleKeyDown(e) {
      if (e.key === "Escape" && isOpen && onClose) {
        onClose();
      }
    }
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  const userComms = useMemo(() => {
    return getCommunicationsForUser(allComms, pubUsername, pubHiddenId);
  }, [allComms, pubUsername, pubHiddenId]);

  const filteredComms = useMemo(() => {
    return userComms.filter((c) => {
      const matchCat = filterCategory === "all" || c.category === filterCategory;
      const matchSearch = !searchQuery.trim() || `${c.note} ${c.createdBy} ${c.category}`.toLowerCase().includes(searchQuery.toLowerCase().trim());
      return matchCat && matchSearch;
    });
  }, [userComms, filterCategory, searchQuery]);

  function handleAddCommunication(e) {
    e.preventDefault();
    if (!note.trim()) {
      alert("Lütfen iletişim detay / açıklama notunu giriniz.");
      return;
    }

    try {
      setSaving(true);
      const newEntry = {
        id: `comm_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
        publisherUsername: pubUsername.replace(/^@+/, ""),
        publisherName: pubFullName,
        hiddenId: pubHiddenId,
        direction: direction,
        category: category,
        status: status,
        note: note.trim(),
        createdBy: currentAuthor,
        createdAt: new Date().toISOString(),
      };

      const updated = [newEntry, ...allComms];
      setAllComms(updated);
      saveAllCommunications(updated);

      setNote("");
      setIsAdding(false);
    } catch (err) {
      alert("Kayıt eklenirken hata: " + err.message);
    } finally {
      setSaving(false);
    }
  }

  function handleDelete(commId) {
    if (!window.confirm("Bu iletişim kaydını silmek istediğinize emin misiniz?")) return;
    const updated = allComms.filter((c) => c.id !== commId);
    setAllComms(updated);
    saveAllCommunications(updated);
  }

  function handleToggleStatus(commId, currentStat) {
    const nextStat = currentStat === "Çözüldü" ? "İşlemde" : "Çözüldü";
    const updated = allComms.map((c) => (c.id === commId ? { ...c, status: nextStat } : c));
    setAllComms(updated);
    saveAllCommunications(updated);
  }

  if (!isOpen || !publisher) return null;

  const resolvedCount = userComms.filter((c) => c.status === "Çözüldü").length;
  const inProgressCount = userComms.filter((c) => c.status !== "Çözüldü").length;

  return (
    <div className="fixed inset-0 z-50 overflow-hidden font-sans">
      {/* KARARTILMIŞ ARKA PLAN (BACKDROP) */}
      <div
        className="fixed inset-0 bg-black/75 backdrop-blur-sm transition-opacity animate-in fade-in duration-300"
        onClick={onClose}
      />

      {/* SAĞDAN KAYAN YAN PANEL (SLIDE-OVER DRAWER) */}
      <div className="fixed inset-y-0 right-0 flex max-w-full pl-6 sm:pl-10">
        <div className="w-screen max-w-xl md:max-w-2xl bg-gradient-to-b from-[#111116] via-[#0d0d12] to-[#08080a] border-l border-yellow-500/25 shadow-2xl flex flex-col h-full animate-in slide-in-from-right duration-300">
          
          {/* HEADER */}
          <div className="p-5 border-b border-white/10 bg-black/50 flex items-center justify-between gap-3">
            <div className="flex items-center gap-3 min-w-0">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-yellow-500/20 text-yellow-300 font-bold border border-yellow-500/30 text-lg shadow-inner">
                💬
              </div>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <div className="text-[10px] font-black uppercase tracking-wider text-yellow-400">
                    WOLF CRM İLETİŞİM MASASI
                  </div>
                  <span className="rounded-full bg-yellow-500/20 border border-yellow-500/30 px-2 py-0.5 text-[10px] font-black text-yellow-300">
                    {userComms.length} Kayıt
                  </span>
                </div>
                <h3 className="text-base font-black text-white truncate">
                  {pubFullName} <span className="text-xs font-normal text-amber-300/80 font-mono">@{pubUsername.replace(/^@+/, "")}</span>
                </h3>
                <div className="mt-0.5 flex flex-wrap items-center gap-2 text-[11px] text-white/50">
                  {pubHiddenId && <span>Hidden ID: <b className="font-mono text-cyan-300">{pubHiddenId}</b></span>}
                  <span>•</span>
                  <span>Yönetici: <b className="text-white/80">{managerName}</b></span>
                </div>
              </div>
            </div>

            <div className="flex items-center gap-2 shrink-0">
              <button
                type="button"
                onClick={() => setIsAdding(!isAdding)}
                className="flex items-center gap-1.5 rounded-xl bg-gradient-to-r from-yellow-500 to-amber-500 px-3 py-2 text-xs font-black text-black hover:brightness-110 active:scale-95 transition shadow-lg"
              >
                <span>{isAdding ? "✕" : "➕"}</span>
                <span className="hidden sm:inline">{isAdding ? "Formu Kapat" : "Yeni Kayıt"}</span>
              </button>

              <button
                type="button"
                onClick={onClose}
                className="flex h-9 w-9 items-center justify-center rounded-xl border border-white/10 text-white/60 hover:text-white hover:bg-white/5 transition"
                title="Paneli Kapat"
              >
                ✕
              </button>
            </div>
          </div>

          {/* İÇERİK (KAYDIRILABİLİR ALAN) */}
          <div className="flex-1 overflow-y-auto p-5 space-y-4 [color-scheme:dark]">
            {/* YENİ KAYIT FORMU */}
            {isAdding && (
              <form onSubmit={handleAddCommunication} className="space-y-3.5 rounded-2xl border border-yellow-500/30 bg-black/80 p-4 shadow-xl animate-in fade-in duration-200">
                <div className="flex items-center justify-between border-b border-white/10 pb-2">
                  <span className="text-xs font-black text-yellow-400 uppercase tracking-wider flex items-center gap-1.5">
                    <span>✍️</span> Yeni İletişim & Destek Girişi
                  </span>
                  <button
                    type="button"
                    onClick={() => setIsAdding(false)}
                    className="text-xs text-white/50 hover:text-white"
                  >
                    Vazgeç ✕
                  </button>
                </div>

                {/* 1. İLETİŞİM YÖNÜ */}
                <div>
                  <span className="mb-1.5 block text-[11px] font-bold text-white/70">1. İletişim Yönü (Kim Kime Ulaştı?)</span>
                  <div className="grid grid-cols-2 gap-2">
                    <button
                      type="button"
                      onClick={() => setDirection("publisher_to_manager")}
                      className={`flex items-center justify-center gap-2 rounded-xl border p-2.5 text-xs font-bold transition ${
                        direction === "publisher_to_manager"
                          ? "border-cyan-500 bg-cyan-500/20 text-cyan-200 shadow-md ring-1 ring-cyan-400"
                          : "border-white/10 bg-white/5 text-white/60 hover:bg-white/10"
                      }`}
                    >
                      <span>📥</span>
                      <span>Yayıncı Ulaştı (Gelen)</span>
                    </button>

                    <button
                      type="button"
                      onClick={() => setDirection("manager_to_publisher")}
                      className={`flex items-center justify-center gap-2 rounded-xl border p-2.5 text-xs font-bold transition ${
                        direction === "manager_to_publisher"
                          ? "border-amber-500 bg-amber-500/20 text-amber-200 shadow-md ring-1 ring-amber-400"
                          : "border-white/10 bg-white/5 text-white/60 hover:bg-white/10"
                      }`}
                    >
                      <span>📤</span>
                      <span>Yönetici Ulaştı (Giden)</span>
                    </button>
                  </div>
                </div>

                {/* 2. KATEGORİ & DURUM */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  <div>
                    <span className="mb-1 block text-[11px] font-bold text-white/70">2. İletişim Konusu / Kategori</span>
                    <select
                      value={category}
                      onChange={(e) => setCategory(e.target.value)}
                      className="w-full rounded-xl border border-white/15 bg-black/90 px-3 py-2 text-xs font-bold text-white outline-none focus:border-yellow-400 [color-scheme:dark]"
                    >
                      {COMMUNICATION_CATEGORIES.map((cat) => (
                        <option key={cat.key} value={cat.key}>
                          {cat.icon} {cat.label}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div>
                    <span className="mb-1 block text-[11px] font-bold text-white/70">3. Takip / Çözüm Durumu</span>
                    <select
                      value={status}
                      onChange={(e) => setStatus(e.target.value)}
                      className="w-full rounded-xl border border-white/15 bg-black/90 px-3 py-2 text-xs font-bold text-white outline-none focus:border-yellow-400 [color-scheme:dark]"
                    >
                      <option value="İşlemde">🟡 İşlemde / Takip Ediliyor</option>
                      <option value="Çözüldü">🟢 Çözüldü / Tamamlandı</option>
                      <option value="Beklemede">⚪ Beklemede / Yanıt Bekleniyor</option>
                    </select>
                  </div>
                </div>

                {/* 3. AÇIKLAMA */}
                <div>
                  <span className="mb-1 block text-[11px] font-bold text-white/70">4. İletişim Detayı & Görüşülen Not</span>
                  <textarea
                    rows={3}
                    required
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                    placeholder="Yayıncının ilettiği talep, soru veya yöneticinin sağladığı destek detaylarını yazınız..."
                    className="w-full rounded-xl border border-white/15 bg-black/90 px-3 py-2 text-xs text-white placeholder:text-white/30 outline-none focus:border-yellow-400"
                  />
                </div>

                <div className="flex items-center justify-end gap-2 pt-1">
                  <button
                    type="button"
                    onClick={() => setIsAdding(false)}
                    className="rounded-xl border border-white/10 px-3.5 py-2 text-xs font-bold text-white/60 hover:text-white"
                  >
                    Vazgeç
                  </button>
                  <button
                    type="submit"
                    disabled={saving}
                    className="rounded-xl bg-gradient-to-r from-yellow-500 to-amber-500 px-4 py-2 text-xs font-black text-black shadow-lg hover:brightness-110 active:scale-95 transition"
                  >
                    {saving ? "Kaydediliyor..." : "✓ İletişim Kaydını Ekle"}
                  </button>
                </div>
              </form>
            )}

            {/* FİLTRE VE ARAMA ÇUBUĞU */}
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2.5 rounded-2xl border border-white/10 bg-black/40 p-3">
              <div className="relative flex-1">
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="İletişim notlarında ara..."
                  className="w-full rounded-xl border border-white/10 bg-black/60 pl-8 pr-3 py-1.5 text-xs text-white placeholder:text-white/40 outline-none focus:border-yellow-400"
                />
                <span className="absolute left-2.5 top-2 text-xs text-white/40">🔍</span>
              </div>

              <select
                value={filterCategory}
                onChange={(e) => setFilterCategory(e.target.value)}
                className="rounded-xl border border-white/10 bg-black/60 px-3 py-1.5 text-xs font-bold text-white outline-none [color-scheme:dark]"
              >
                <option value="all">Tüm Kategoriler ({userComms.length})</option>
                {COMMUNICATION_CATEGORIES.map((c) => {
                  const count = userComms.filter((item) => item.category === c.key).length;
                  return (
                    <option key={c.key} value={c.key}>
                      {c.icon} {c.label} ({count})
                    </option>
                  );
                })}
              </select>
            </div>

            {/* NUMARALANDIRILMIŞ İLETİŞİM GEÇMİŞİ (1, 2, 3... 30, 40) */}
            {filteredComms.length === 0 ? (
              <div className="rounded-2xl border border-dashed border-white/10 bg-white/[0.02] p-10 text-center text-xs text-white/40 space-y-2">
                <div className="text-2xl">💬</div>
                <div>
                  {userComms.length === 0
                    ? "Bu yayıncı için henüz iletişim kaydı girilmemiş. Yukarıdaki 'Yeni Kayıt' butonundan ilk görüşmeyi kaydedebilirsiniz."
                    : "Arama veya filtre kriterine uygun kayıt bulunamadı."}
                </div>
              </div>
            ) : (
              <div className="space-y-3">
                {filteredComms.map((item, index) => {
                  const rowNumber = filteredComms.length - index;
                  const isPubToMgr = item.direction === "publisher_to_manager";
                  const catDef = COMMUNICATION_CATEGORIES.find((c) => c.key === item.category) || {
                    icon: "💬",
                    color: "bg-white/10 text-white/80 border-white/20",
                  };
                  const isResolved = item.status === "Çözüldü";

                  return (
                    <div
                      key={item.id || index}
                      className={`relative rounded-2xl border p-4 transition shadow-lg ${
                        isResolved
                          ? "border-emerald-500/20 bg-emerald-950/10 hover:border-emerald-500/30"
                          : "border-white/10 bg-black/50 hover:border-white/20"
                      }`}
                    >
                      {/* SATIR BAŞLIĞI */}
                      <div className="flex flex-wrap items-center justify-between gap-2 border-b border-white/5 pb-2.5">
                        <div className="flex flex-wrap items-center gap-2">
                          {/* 1, 2, 3, 4... NUMARA ROZETİ */}
                          <span className="flex h-6 w-6 items-center justify-center rounded-xl bg-yellow-500/20 text-yellow-300 font-black text-xs border border-yellow-500/30 shadow-sm">
                            {rowNumber}
                          </span>

                          {/* İLETİŞİM YÖNÜ ROZETİ */}
                          <span
                            className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[10px] font-black border ${
                              isPubToMgr
                                ? "bg-cyan-500/20 text-cyan-300 border-cyan-500/30"
                                : "bg-amber-500/20 text-amber-300 border-amber-500/30"
                            }`}
                          >
                            <span>{isPubToMgr ? "📥" : "📤"}</span>
                            <span>{isPubToMgr ? "Yayıncı Ulaştı" : "Yönetici Ulaştı"}</span>
                          </span>

                          {/* KATEGORİ ROZETİ */}
                          <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[10px] font-black border ${catDef.color}`}>
                            <span>{catDef.icon}</span>
                            <span>{item.category}</span>
                          </span>

                          {/* DURUM ROZETİ */}
                          <button
                            type="button"
                            onClick={() => handleToggleStatus(item.id, item.status)}
                            title="Durumu değiştirmek için tıklayın (Çözüldü / İşlemde)"
                            className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[10px] font-black border transition active:scale-95 ${
                              isResolved
                                ? "bg-emerald-500/20 text-emerald-300 border-emerald-500/40 hover:bg-emerald-500/30"
                                : item.status === "Beklemede"
                                ? "bg-slate-500/20 text-slate-300 border-slate-500/40 hover:bg-slate-500/30"
                                : "bg-amber-500/20 text-amber-300 border-amber-500/40 hover:bg-amber-500/30"
                            }`}
                          >
                            <span>{isResolved ? "✓" : "⏳"}</span>
                            <span>{item.status || "İşlemde"}</span>
                          </button>
                        </div>

                        <div className="flex items-center gap-3 text-[11px] text-white/50">
                          <span>👤 {item.createdBy || "Yetkili"}</span>
                          <span>📅 {formatDateTimeTr(item.createdAt)}</span>
                          <button
                            type="button"
                            onClick={() => handleDelete(item.id)}
                            className="text-white/40 hover:text-red-400 transition"
                            title="Bu kaydı sil"
                          >
                            🗑️
                          </button>
                        </div>
                      </div>

                      {/* NOT METNİ */}
                      <div className="mt-2.5 text-xs leading-relaxed text-white/90 whitespace-pre-wrap pl-8">
                        {item.note}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>

          {/* FOOTER */}
          <div className="p-4 border-t border-white/10 bg-black/60 flex items-center justify-between text-xs text-white/60">
            <div className="flex items-center gap-3">
              <span>Toplam: <b className="text-white">{userComms.length}</b></span>
              <span>•</span>
              <span className="text-emerald-400">Çözüldü: <b>{resolvedCount}</b></span>
              <span>•</span>
              <span className="text-amber-400">İşlemde: <b>{inProgressCount}</b></span>
            </div>

            <button
              type="button"
              onClick={onClose}
              className="rounded-xl border border-white/10 px-4 py-1.5 text-xs font-bold text-white hover:bg-white/10 transition"
            >
              Kapat
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

/**
 * Reusable Mini CRM Drawer/Timeline component
 */
export function PublisherCrmDrawer({
  publisher = {},
  currentUser = null,
  onClose = null,
  embedded = true,
}) {
  const [allComms, setAllComms] = useState(loadAllCommunications);
  const [isAdding, setIsAdding] = useState(false);
  const [direction, setDirection] = useState("publisher_to_manager");
  const [category, setCategory] = useState("Talep");
  const [status, setStatus] = useState("İşlemde");
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);
  const [filterCategory, setFilterCategory] = useState("all");

  const pubUsername = publisher.tiktok_username || publisher.username || "";
  const pubHiddenId = publisher.hidden_id || publisher.hiddenId || "";
  const pubFullName = publisher.full_name || publisher.fullName || pubUsername;
  const currentAuthor = currentUser?.fullName || currentUser?.username || "admin";

  useEffect(() => {
    function handleUpdate() {
      setAllComms(loadAllCommunications());
    }
    window.addEventListener("wolf_crm_updated", handleUpdate);
    window.addEventListener("storage", handleUpdate);
    return () => {
      window.removeEventListener("wolf_crm_updated", handleUpdate);
      window.removeEventListener("storage", handleUpdate);
    };
  }, []);

  const userComms = useMemo(() => {
    return getCommunicationsForUser(allComms, pubUsername, pubHiddenId);
  }, [allComms, pubUsername, pubHiddenId]);

  const filteredComms = useMemo(() => {
    if (filterCategory === "all") return userComms;
    return userComms.filter((c) => c.category === filterCategory);
  }, [userComms, filterCategory]);

  function handleAddCommunication(e) {
    e.preventDefault();
    if (!note.trim()) {
      alert("Lütfen iletişim detay / açıklama notunu giriniz.");
      return;
    }

    try {
      setSaving(true);
      const newEntry = {
        id: `comm_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`,
        publisherUsername: pubUsername.replace(/^@+/, ""),
        publisherName: pubFullName,
        hiddenId: pubHiddenId,
        direction: direction,
        category: category,
        status: status,
        note: note.trim(),
        createdBy: currentAuthor,
        createdAt: new Date().toISOString(),
      };

      const updated = [newEntry, ...allComms];
      setAllComms(updated);
      saveAllCommunications(updated);

      setNote("");
      setIsAdding(false);
    } catch (err) {
      alert("Kayıt eklenirken hata: " + err.message);
    } finally {
      setSaving(false);
    }
  }

  function handleDelete(commId) {
    if (!window.confirm("Bu iletişim kaydını silmek istediğinize emin misiniz?")) return;
    const updated = allComms.filter((c) => c.id !== commId);
    setAllComms(updated);
    saveAllCommunications(updated);
  }

  function handleToggleStatus(commId, currentStat) {
    const nextStat = currentStat === "Çözüldü" ? "İşlemde" : "Çözüldü";
    const updated = allComms.map((c) => (c.id === commId ? { ...c, status: nextStat } : c));
    setAllComms(updated);
    saveAllCommunications(updated);
  }

  return (
    <div className={`mt-3 rounded-2xl border border-yellow-500/30 bg-gradient-to-b from-[#121217] to-[#0a0a0e] p-4 text-white shadow-2xl ${embedded ? "" : "w-full"}`}>
      {/* HEADER */}
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between border-b border-white/10 pb-3">
        <div className="flex items-center gap-2.5">
          <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-yellow-500/20 text-yellow-300 font-bold border border-yellow-500/30 text-sm">
            💬
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h4 className="text-sm font-black text-white">Yayıncı İletişim & CRM Takip Masası</h4>
              <span className="rounded-full bg-yellow-500/20 border border-yellow-500/30 px-2 py-0.5 text-[10px] font-black text-yellow-300">
                {userComms.length} Kayıt
              </span>
            </div>
            <div className="text-[11px] text-white/50">
              <span className="font-semibold text-white/80">{pubFullName}</span> ({pubUsername}) {pubHiddenId && `• Hidden ID: ${pubHiddenId}`}
            </div>
          </div>
        </div>

        <div className="flex items-center gap-2">
          {!isAdding && (
            <button
              type="button"
              onClick={() => setIsAdding(true)}
              className="flex items-center gap-1.5 rounded-xl bg-yellow-500 px-3 py-1.5 text-xs font-black text-black hover:bg-yellow-400 active:scale-95 transition shadow-lg"
            >
              <span>➕</span>
              <span>Yeni İletişim Kaydı Ekle</span>
            </button>
          )}

          {onClose && (
            <button
              type="button"
              onClick={onClose}
              className="rounded-xl border border-white/10 p-1.5 text-xs text-white/60 hover:text-white hover:bg-white/5"
              title="Kapat"
            >
              ✕
            </button>
          )}
        </div>
      </div>

      {/* FORM (EĞER AÇIKSA) */}
      {isAdding && (
        <form onSubmit={handleAddCommunication} className="mt-3.5 space-y-3 rounded-2xl border border-white/15 bg-black/60 p-4 animate-in fade-in duration-200">
          <div className="flex items-center justify-between border-b border-white/10 pb-2">
            <span className="text-xs font-black text-yellow-400 uppercase tracking-wider flex items-center gap-1.5">
              <span>✍️</span> Yeni İletişim / Talep Girişi
            </span>
            <button
              type="button"
              onClick={() => setIsAdding(false)}
              className="text-xs text-white/50 hover:text-white"
            >
              İptal ✕
            </button>
          </div>

          {/* 1. İLETİŞİM YÖNÜ SEÇİMİ */}
          <div>
            <span className="mb-1.5 block text-[11px] font-bold text-white/70">1. İletişim Yönü (Kim Kime Ulaştı?)</span>
            <div className="grid grid-cols-2 gap-2">
              <button
                type="button"
                onClick={() => setDirection("publisher_to_manager")}
                className={`flex items-center justify-center gap-2 rounded-xl border p-2.5 text-xs font-bold transition ${
                  direction === "publisher_to_manager"
                    ? "border-cyan-500 bg-cyan-500/20 text-cyan-200 shadow-md ring-1 ring-cyan-400"
                    : "border-white/10 bg-white/5 text-white/60 hover:bg-white/10"
                }`}
              >
                <span>📥</span>
                <span>Yayıncı Ulaştı (Gelen)</span>
              </button>

              <button
                type="button"
                onClick={() => setDirection("manager_to_publisher")}
                className={`flex items-center justify-center gap-2 rounded-xl border p-2.5 text-xs font-bold transition ${
                  direction === "manager_to_publisher"
                    ? "border-amber-500 bg-amber-500/20 text-amber-200 shadow-md ring-1 ring-amber-400"
                    : "border-white/10 bg-white/5 text-white/60 hover:bg-white/10"
                }`}
              >
                <span>📤</span>
                <span>Yönetici Ulaştı (Giden)</span>
              </button>
            </div>
          </div>

          {/* 2. KATEGORİ & DURUM */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div>
              <span className="mb-1 block text-[11px] font-bold text-white/70">2. İletişim Konusu / Kategori</span>
              <select
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                className="w-full rounded-xl border border-white/15 bg-black/80 px-3 py-2 text-xs font-bold text-white outline-none focus:border-yellow-400 [color-scheme:dark]"
              >
                {COMMUNICATION_CATEGORIES.map((cat) => (
                  <option key={cat.key} value={cat.key}>
                    {cat.icon} {cat.label}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <span className="mb-1 block text-[11px] font-bold text-white/70">3. Takip / Çözüm Durumu</span>
              <select
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                className="w-full rounded-xl border border-white/15 bg-black/80 px-3 py-2 text-xs font-bold text-white outline-none focus:border-yellow-400 [color-scheme:dark]"
              >
                <option value="İşlemde">🟡 İşlemde / Takip Ediliyor</option>
                <option value="Çözüldü">🟢 Çözüldü / Tamamlandı</option>
                <option value="Beklemede">⚪ Beklemede / Yanıt Bekleniyor</option>
              </select>
            </div>
          </div>

          {/* 3. AÇIKLAMA */}
          <div>
            <span className="mb-1 block text-[11px] font-bold text-white/70">4. İletişim Detayı & Görüşülen Not</span>
            <textarea
              rows={3}
              required
              value={note}
              onChange={(e) => setNote(e.target.value)}
              placeholder="Yayıncının ilettiği talep, soru veya yöneticinin sağladığı destek detaylarını yazınız..."
              className="w-full rounded-xl border border-white/15 bg-black/80 px-3 py-2 text-xs text-white placeholder:text-white/30 outline-none focus:border-yellow-400"
            />
          </div>

          <div className="flex items-center justify-end gap-2 pt-1">
            <button
              type="button"
              onClick={() => setIsAdding(false)}
              className="rounded-xl border border-white/10 px-3.5 py-2 text-xs font-bold text-white/60 hover:text-white"
            >
              Vazgeç
            </button>
            <button
              type="submit"
              disabled={saving}
              className="rounded-xl bg-gradient-to-r from-yellow-500 to-amber-500 px-4 py-2 text-xs font-black text-black shadow-lg hover:brightness-110 active:scale-95 transition"
            >
              {saving ? "Kaydediliyor..." : "✓ İletişim Kaydını Ekle"}
            </button>
          </div>
        </form>
      )}

      {/* FİLTRE VE LİSTE BÖLÜMÜ */}
      <div className="mt-3 space-y-2">
        {userComms.length > 0 && (
          <div className="flex flex-wrap items-center justify-between gap-2 text-[11px] text-white/60 border-b border-white/5 pb-2">
            <div className="font-bold uppercase tracking-wider text-yellow-300">
              İletişim & Talep Geçmişi ({userComms.length} Toplam)
            </div>
            <div className="flex items-center gap-1.5">
              <span>Filtre:</span>
              <select
                value={filterCategory}
                onChange={(e) => setFilterCategory(e.target.value)}
                className="rounded-lg border border-white/10 bg-black/60 px-2 py-1 text-[11px] text-white outline-none [color-scheme:dark]"
              >
                <option value="all">Tüm Kategoriler</option>
                {COMMUNICATION_CATEGORIES.map((c) => (
                  <option key={c.key} value={c.key}>{c.label}</option>
                ))}
              </select>
            </div>
          </div>
        )}

        {/* NUMARALANDIRILMIŞ İLETİŞİM SATIRLARI (1, 2, 3, 4...) */}
        {filteredComms.length === 0 ? (
          <div className="rounded-xl border border-dashed border-white/10 bg-white/[0.02] p-6 text-center text-xs text-white/40">
            {userComms.length === 0
              ? "Henüz iletişim kaydı bulunmuyor. Yukarıdaki 'Yeni İletişim Kaydı Ekle' butonuna basarak ilk kaydı oluşturabilirsiniz."
              : "Seçili filtreye uygun iletişim kaydı bulunamadı."}
          </div>
        ) : (
          <div className="space-y-2.5">
            {filteredComms.map((item, index) => {
              const rowNumber = filteredComms.length - index;
              const isPubToMgr = item.direction === "publisher_to_manager";
              const catDef = COMMUNICATION_CATEGORIES.find((c) => c.key === item.category) || {
                icon: "💬",
                color: "bg-white/10 text-white/80 border-white/20",
              };
              const isResolved = item.status === "Çözüldü";

              return (
                <div
                  key={item.id || index}
                  className={`relative rounded-xl border p-3.5 transition ${
                    isResolved
                      ? "border-emerald-500/20 bg-emerald-950/10 hover:border-emerald-500/30"
                      : "border-white/10 bg-black/40 hover:border-white/20"
                  }`}
                >
                  <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2 border-b border-white/5 pb-2">
                    <div className="flex flex-wrap items-center gap-2">
                      {/* 1, 2, 3... NUMARA ROZETİ */}
                      <span className="flex h-5 w-5 items-center justify-center rounded-lg bg-yellow-500/20 text-yellow-300 font-black text-[11px] border border-yellow-500/30">
                        {rowNumber}
                      </span>

                      {/* İLETİŞİM YÖNÜ ROZETİ */}
                      <span
                        className={`inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-[10px] font-black border ${
                          isPubToMgr
                            ? "bg-cyan-500/20 text-cyan-300 border-cyan-500/30"
                            : "bg-amber-500/20 text-amber-300 border-amber-500/30"
                        }`}
                      >
                        <span>{isPubToMgr ? "📥" : "📤"}</span>
                        <span>{isPubToMgr ? "Yayıncı Ulaştı" : "Yönetici Ulaştı"}</span>
                      </span>

                      {/* KATEGORİ ROZETİ */}
                      <span className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-black border ${catDef.color}`}>
                        <span>{catDef.icon}</span>
                        <span>{item.category}</span>
                      </span>

                      {/* DURUM ROZETİ */}
                      <button
                        type="button"
                        onClick={() => handleToggleStatus(item.id, item.status)}
                        title="Durumu değiştirmek için tıklayın"
                        className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-black border transition ${
                          isResolved
                            ? "bg-emerald-500/20 text-emerald-300 border-emerald-500/40 hover:bg-emerald-500/30"
                            : item.status === "Beklemede"
                            ? "bg-slate-500/20 text-slate-300 border-slate-500/40 hover:bg-slate-500/30"
                            : "bg-amber-500/20 text-amber-300 border-amber-500/40 hover:bg-amber-500/30"
                        }`}
                      >
                        <span>{isResolved ? "✓" : "⏳"}</span>
                        <span>{item.status || "İşlemde"}</span>
                      </button>
                    </div>

                    <div className="flex items-center gap-3 text-[11px] text-white/50">
                      <span>👤 {item.createdBy || "Yetkili"}</span>
                      <span>📅 {formatDateTimeTr(item.createdAt)}</span>
                      <button
                        type="button"
                        onClick={() => handleDelete(item.id)}
                        className="text-white/40 hover:text-red-400 transition"
                        title="Bu kaydı sil"
                      >
                        🗑️
                      </button>
                    </div>
                  </div>

                  {/* NOT METNİ */}
                  <div className="mt-2 text-xs leading-relaxed text-white/90 whitespace-pre-wrap pl-7">
                    {item.note}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

/**
 * CRM Modal wrapper for table views
 */
export function PublisherCrmModal({
  publisher = {},
  currentUser = null,
  onClose,
}) {
  if (!publisher) return null;

  return (
    <PublisherCrmSlideOver
      publisher={publisher}
      currentUser={currentUser}
      isOpen={Boolean(publisher)}
      onClose={onClose}
    />
  );
}

/**
 * Trigger badge button that shows counter
 */
export function PublisherCrmBadgeButton({
  publisher = {},
  onClick,
  className = "",
}) {
  const [allComms, setAllComms] = useState(loadAllCommunications);

  useEffect(() => {
    function handleUpdate() {
      setAllComms(loadAllCommunications());
    }
    window.addEventListener("wolf_crm_updated", handleUpdate);
    window.addEventListener("storage", handleUpdate);
    return () => {
      window.removeEventListener("wolf_crm_updated", handleUpdate);
      window.removeEventListener("storage", handleUpdate);
    };
  }, []);

  const pubUsername = publisher.tiktok_username || publisher.username || "";
  const pubHiddenId = publisher.hidden_id || publisher.hiddenId || "";
  const count = getCommunicationsForUser(allComms, pubUsername, pubHiddenId).length;

  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center gap-1.5 rounded-xl border px-3 py-1.5 text-xs font-black transition active:scale-95 cursor-pointer ${
        count > 0
          ? "border-yellow-500/40 bg-yellow-500/15 text-yellow-300 hover:bg-yellow-500/25 shadow-sm"
          : "border-white/10 bg-white/5 text-white/60 hover:text-white hover:bg-white/10"
      } ${className}`}
      title="İletişim & CRM Masasını Yanda Aç"
    >
      <span>💬</span>
      <span>İletişim</span>
      <span className={`rounded-full px-1.5 py-0.2 text-[10px] font-black ${
        count > 0 ? "bg-yellow-400 text-black" : "bg-white/10 text-white/60"
      }`}>
        {count}
      </span>
      <span className="text-[10px] text-white/40">›</span>
    </button>
  );
}
